function SentryTest() {
	return (
		<div>
			<button
				type="button"
				onClick={() => {
					throw new Error("Sentry Test Error");
				}}
			>
				Probar Sentry
			</button>
		</div>
	);
}

export default SentryTest;
